import { Box, Button, Modal, TextField } from '@mui/material';
import { ChevronDown } from 'lucide-react';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { GroupType } from 'type/type';
import MTGroupList from './MTGroupList';
import React from 'react';
import { useWhapiGroups, useWhapiTags } from 'context';
interface Props {
  tagLabel: string;
}

const ManageTag = ({ tagLabel }: Props) => {
  const emptyGroupForm: GroupType = {
    PartitionKey: '',
    RowKey: '',
    id: '',
    fn: '',
    type: '',
    participants: [],
  };
  const [addNewState, setAddNewState] = useState<boolean>(false);
  const [newGroupForm, setNewGroupForm] = useState<GroupType>(emptyGroupForm);

  const groups = useWhapiGroups();
  const primaryGroup = groups?.filter(group => group.name === tagLabel) ?? [];
  const otherGroups = groups?.filter(group => group.name !== tagLabel) ?? [];
  console.log('otherGroups', otherGroups);
  return (
    <Box sx={{ minWidth: '400px' }}>
      <Box style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: ' 20px', borderBottom: '1px solid var(--black01)' }}>
        <p className={'text-overflow'} style={{ fontWeight: 600, fontSize: 16, opacity: 0.7 }}>
          {tagLabel}
        </p>
        <p style={{ fontWeight: 600, fontSize: 16, opacity: 0.7 }}>-</p>
        <p style={{ fontWeight: 600, fontSize: 16, opacity: 0.7 }}>Management</p>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', padding: '10px 20px', backgroundColor: 'var(--black01)' }}>
        <Button size={'small'} variant={'outlined'} sx={{ display: 'flex', gap: '10px', alignItems: 'center' }} onClick={() => setAddNewState(!addNewState)}>
          {addNewState ? <ChevronDown size={16} /> : <ChevronDown size={16} style={{ transform: 'rotate(180deg)', transition: '0.5s ease-in-out' }} />}
          <p style={{ fontSize: '10px' }}>Add New Group</p>
        </Button>
        {addNewState && (
          <Box sx={{ padding: '10px 20px' }}>
            <p style={{ padding: '10px 0', opacity: 0.7, fontWeight: 600 }}>New Group Form</p>
            <form style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              <TextField label={'Partition Key'} value={newGroupForm.PartitionKey} onChange={e => setNewGroupForm(prev => ({ ...prev, PartitionKey: e.target.value }))} size={'small'} />
              <TextField label={'Row Key'} value={newGroupForm.RowKey} onChange={e => setNewGroupForm(prev => ({ ...prev, RowKey: e.target.value }))} size={'small'} />
              <TextField label={'Friendly Name'} value={newGroupForm.fn} onChange={e => setNewGroupForm(prev => ({ ...prev, fn: e.target.value }))} size={'small'} />
              <TextField label={'Type'} value={newGroupForm.type} onChange={e => setNewGroupForm(prev => ({ ...prev, type: e.target.value }))} size={'small'} />
              <TextField label={'Participant'} value={newGroupForm.fn} onChange={e => setNewGroupForm(prev => ({ ...prev, fn: e.target.value }))} size={'small'} />
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button variant={'text'} onClick={() => setNewGroupForm(emptyGroupForm)} color={'secondary'}>
                  Reset Form
                </Button>
                <Button
                  variant={'contained'}
                  sx={{ fontSize: '9px' }}
                  onClick={() => {
                    setNewGroupForm(emptyGroupForm);
                    setAddNewState(false);
                    toast.success('Group Added Successfully!');
                  }}
                >
                  Add to Tag&apos;s Groups
                </Button>
              </Box>
            </form>
          </Box>
        )}
      </Box>

      {primaryGroup[0] && <MTGroupList tagLabel={tagLabel} tagData={primaryGroup[0]} />}
      {otherGroups && otherGroups.map((tag, index) => <MTGroupList tagLabel={tagLabel} tagData={tag} key={index} />)}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', padding: '10px 20px', borderTop: '1px solid var(--black01)' }}>
        <Button color={'secondary'}>Reset</Button>
        <Button variant={'contained'}>Save All Changes</Button>
      </Box>
    </Box>
  );
};

export default ManageTag;
